import { createContext } from 'react'
import { defaultLeadCardContext, LeadCardContext } from './LeadCardContext.types'

export const leadCardContext = createContext<LeadCardContext>(defaultLeadCardContext)
